"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _checkboxConfig = _interopRequireDefault(require("./checkbox-config"));
var _styledCheckbox = require("./styled-checkbox");
var _excluded = ["className", "dataTestId", "errorMessage", "fullWidth", "marginBottom", "style", "componentId"];
/* eslint-disable react/jsx-props-no-spreading */
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useMemo = _react["default"].useMemo;
var propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  name: _propTypes["default"].string.isRequired,
  analyticsId: _propTypes["default"].string,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  isChecked: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  marginBottom: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].object,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  componentId: _propTypes["default"].string
};
var defaultProps = {
  analyticsId: '',
  className: '',
  dataTestId: '',
  errorMessage: '',
  fullWidth: false,
  isChecked: false,
  isDisabled: false,
  marginBottom: false,
  onChange: undefined,
  style: undefined,
  value: '',
  componentId: (0, _fuseUtils.uuid)()
};
var Checkbox = exports.Checkbox = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    dataTestId = _ref.dataTestId,
    errorMessage = _ref.errorMessage,
    fullWidth = _ref.fullWidth,
    marginBottom = _ref.marginBottom,
    style = _ref.style,
    componentId = _ref.componentId,
    props = _objectWithoutProperties(_ref, _excluded);
  var errorIcon = _checkboxConfig["default"].errorIcon,
    errorText = _checkboxConfig["default"].errorText;
  // Populate errorMessageId only if there is error message, and pass this to base input aria-describedby
  var errorMessageId = errorMessage && useMemo(function () {
    return "".concat(componentId, "-").concat(errorText.className, "-").concat(errorMessage);
  });
  return /*#__PURE__*/_react["default"].createElement(_styledCheckbox.StyledCheckbox, {
    className: className,
    "data-testid": dataTestId || 'fuse-checkbox',
    fullWidth: fullWidth,
    marginBottom: marginBottom,
    ref: ref,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_styledCheckbox.StyledCheckboxInput, _extends({
    componentId: componentId,
    errorMessageId: errorMessageId || undefined,
    isError: !!errorMessage
  }, props)), errorMessage && /*#__PURE__*/_react["default"].createElement(_styledCheckbox.StyledCheckboxError, null, /*#__PURE__*/_react["default"].createElement(_styledCheckbox.StyledErrorIcon, {
    icon: errorIcon.icon,
    color: errorIcon.color,
    className: errorIcon.className,
    "data-testid": errorIcon.dataTestId,
    responsiveSize: errorIcon.size
  }), /*#__PURE__*/_react["default"].createElement(_styledCheckbox.StyledErrorText, {
    id: errorMessageId,
    color: errorText.color,
    className: errorText.className,
    dataTestId: errorText.dataTestId,
    size: errorText.size,
    tag: errorText.tag,
    type: errorText.type
  }, errorMessage)));
});
Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
var _default = exports["default"] = Checkbox;